/**
 * Escolha do texto de erro da tela de login.
 *
 * Fica separada do `Login.tsx` por ser lógica pura — é o que permite testá-la
 * com `node --test`, que remove tipos de `.ts` mas não compila JSX.
 *
 * A regra que atravessa o arquivo: **a tela nunca é mais informativa que o
 * servidor.** O `POST /api/login` responde o mesmo 401 com o mesmo texto para
 * "usuário não existe", "senha errada" e "conta travada" (ver
 * `servidor/rotas/autenticacao.js`); repetir esse texto sem interpretar é o que
 * mantém a promessa. Só dois casos ganham texto próprio, e nenhum deles é
 * credencial.
 */

/** Pedido que não chegou a ter resposta: rede, DNS, túnel caído. */
export const SEM_RESPOSTA = 'sem resposta do servidor'

/** 429 não é credencial errada, e dizer isso evita mais dez tentativas. */
export const MUITAS_TENTATIVAS = 'muitas tentativas, aguarde'

/** Usada quando o status não trouxe texto algum — ver a nota em `mensagemDeErro`. */
export const FALHA_GENERICA = 'não foi possível entrar; tente de novo'

/** O que o `api.ts` põe na mensagem quando a resposta não tem JSON com `erro`. */
const PLACEHOLDER_SEM_CORPO = /^falha \d+$/

/**
 * @param status  código HTTP da resposta, ou `null` quando não houve resposta
 * @param mensagemDoServidor  o `erro` que veio no corpo, já extraído pelo `api.ts`
 */
export function mensagemDeErro(status: number | null, mensagemDoServidor: string): string {
  if (status === null) return SEM_RESPOSTA

  /* O 429 tem texto fixo nosso, e não o do corpo, porque o limite de taxa pode
     vir de duas pontas: a rota de login (que manda texto bom) e o proxy na
     frente dela na AWS (que manda HTML, e aí o corpo não tem `erro` nenhum). */
  if (status === 429) return MUITAS_TENTATIVAS

  const texto = mensagemDoServidor.trim()
  /* `falha 502` na tela não informa quem liga o telão. Trocar o placeholder por
     texto em português não acrescenta informação — só torna legível a mesma
     ausência de informação. */
  if (texto === '' || PLACEHOLDER_SEM_CORPO.test(texto)) return FALHA_GENERICA
  return texto
}
